import { COLOR_PRIMARY, COLOR_PRIMARY_LIGHT } from "#constants/Styles"
import { Paper, Typography } from "@mui/material"

export const EvaluationCardScore = ({ label, value, gradient = 0 }) => {
	return (
		<Paper
			sx={{
				p: 2.5,
				textAlign: "center",
				borderRadius: 2,
				background: `linear-gradient(135deg, ${COLOR_PRIMARY} ${gradient}%, ${COLOR_PRIMARY_LIGHT} 100%)`,
				color: "white",
			}}
		>
			<Typography variant="h5" sx={{ fontWeight: 700 }}>
				{value}
			</Typography>
			<Typography variant="body2" sx={{ opacity: 0.9 }}>
				{label}
			</Typography>
		</Paper>
	)
}
